<template>
  <Network v-if="networkError" @refreshs="refresh" />
  <div v-else-if="dataContent" class="mainContent">
    <ul v-if="trainingList.length > 0">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="trainingList.length >= 20 ? '没有更多了' : ''"
        :immediate-check="false"
        @load="handleLoadMore"
      >
        <li v-for="(item, index) in trainingList" :key="index">
          <div class="title">
            {{ item.title }}
          </div>
          <div class="content_box">
            <div
              v-html="item.content"
              class="contentDiv"
              :style="custoStyle"
            ></div>
            <!-- <div class="action_box" @click="handleCheckItem(item)">
              <span>{{ isStowed ? "展开" : "收起" }}</span>
            </div> -->
          </div>
        </li>
      </van-list>
    </ul>
    <div v-else-if="isEmpty" class="emptyBox">
      <img src="@/assets/images/v2_empty.png" alt />
      <p>暂无数据</p>
    </div>
  </div>
  <Loading v-else />
</template>
<script>
import Network from "@/components/network";
import Loading from "@/components/loading";
import { handleBuryPoint, interErrorMonitor } from "@/utils/tool";
import { reqTrainingList } from "@/apis/serviceApi";
export default {
  components: {
    Network,
    Loading,
  },
  data() {
    return {
      networkError: false,
      dataContent: false,
      trainingList: [], // 培训资料列表
      loading: false,
      finished: false,
      isEmpty: false, // 空数据
      isStowed: true,
      custoStyle: {},
    };
  },
  created() {
    this.getTrainingList();
    handleBuryPoint("h5-sudaseeker_trainingPage", "show", {
      ...this.$route.query,
    });
  },
  methods: {
    handleCheckItem(item) {
      console.log("item", item);
      this.custoStyle = {
        height: this.isStowed ? "auto" : "26px",
      };
      this.isStowed = !this.isStowed;
    },
    handleLoadMore() {
      this.dataContent = true;
      this.getTrainingList();
    },
    getTrainingList() {
      const { groupId } = this.$route.query;
      const params = {
        groupId,
      };
      // console.log("🍊reqTrainingList-params", params);
      reqTrainingList(params)
        .then((res) => {
          // console.log("🍊reqTrainingList-res", res);
          if (res.code === 1) {
            this.dataContent = true;
            this.finished = true;
            this.loading = false;
            this.trainingList = res.data || [];
            this.isEmpty = this.trainingList.length === 0;
          } else {
            this.networkError = true;
            handleBuryPoint(
              "h5-sudaseeker_trainingPage",
              "reqTrainingList-err",
              { ...res }
            );
            interErrorMonitor({
              msg: `培训资料列表接口请求失败，code:${
                res.code
              },params:${JSON.stringify(params)}`,
            });
          }
        })
        .catch((err) => {
          console.log("reqTrainingList-err", err);
          this.networkError = true;
          handleBuryPoint("h5-sudaseeker_trainingPage", "reqTrainingList-err", {
            ...err,
          });
          interErrorMonitor({
            msg: `培训资料列表接口catch，params:${JSON.stringify(params)}`,
          });
        });
    },
    refresh() {
      this.dataContent = false;
      this.networkError = false;
      this.getTrainingList();
    },
  },
};
</script>
<style lang="less" scoped>
.mainContent {
  width: 100%;
  height: 100vh;
  background-color: #f9f9f9;
  padding: 20px;
  * {
    box-sizing: border-box;
  }
  ul {
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);
    border-radius: 12px;
    background-color: #fff;
    li {
      padding: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      border-radius: 20px;
      .title {
        font-size: 44px;
        font-weight: bold;
        color: rgba(34, 34, 34, 0.9);
        margin-bottom: 10px;
      }
      .content_box {
        // position: relative;
        // height: 226px;
        // background: cyan;
        // overflow-y: hidden;
        // padding: 0 0 20px 0;
        .contentDiv {
          width: 100%;
          word-break: break-all; // 分割字母
          font-size: 18px;
        }
        .action_box {
          // position: absolute;
          // display: flex;
          // top: 0px;
          // right: 0px;
          padding: 10px;
          display: flex;
          justify-content: flex-end;
          span {
            font-size: 32px;
            color: #2541f2;
          }
        }
      }
    }
  }
  .emptyBox {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 740px;
    justify-content: center;
    img {
      width: 168px;
      height: 168px;
      margin: 0 0 20px;
    }
    p {
      font-size: 32px;
      color: #333333;
    }
  }
}
</style>